import { useEffect, useCallback } from 'react';

import { triggerPrompt } from './triggerPrompt';

export function useSaveChangesPrompt(condition: boolean): void {
  const onBeforeUnload = useCallback(
    (e: BeforeUnloadEvent) => triggerPrompt(e, condition),
    [condition]
  );
  useEffect(() => {
    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [condition, onBeforeUnload]);
}

export default useSaveChangesPrompt;
